import { SignInRefusalReason } from "@/utils/SignInRefusal";

export enum LoginResult {
  SUCCESS,
  NO_MATCHING_CLIENT_OR_USER,
  USER_BLOCKED,
  WRONG_PASSWORD,
  SHARED_EMAIL_ADDRESS,
  FAILURE,
  NO_INTERNET_CONNECTION,
  NETWORK_BLOCKED,
  /** The client is blocked or deleted (#2610066). */
  CLIENT_BLOCKED,
}

/** The login result for a refusal IRES Cloud sent (#2610066). */
export function loginResultForRefusal(reason: SignInRefusalReason): LoginResult {
  return reason === "USER_BLOCKED" ? LoginResult.USER_BLOCKED : LoginResult.CLIENT_BLOCKED;
}

export enum LoginTarget {
  CLIENT,
  USER,
}
